import { TextFilterType } from '../../../../../types';
import { TeamNewFinStatusReasonTagID } from '../../../../../main/teams/teamsTypes';

export type UniversalFilterCompanyNewFinTagID = TeamNewFinStatusReasonTagID;

export const enum UniversalFilterCompanyFinCategoriesModes {
  IS_ANY_OF = 'is_any_of',
  IS_NONE_OF = 'is_none_of'
}

export type UniversalFilterCompanyFinCategoriesValue = TextFilterType;

export type UniversalFilterCompanyFinCategoriesFilterState = {
  mode: UniversalFilterCompanyFinCategoriesModes;
  categoryIds?: UniversalFilterCompanyNewFinTagID[];
};

export type UniversalFilterCompanyFinCategoriesOnFilterStateChange = (
  state: UniversalFilterCompanyFinCategoriesFilterState
) => void;

export type UniversalFilterCompanyFinCategoriesOnChange = (
  value?: UniversalFilterCompanyFinCategoriesValue
) => void;
